import { createFetchThunk } from "../common/commonFetchThunk.js";
import { getServiceApi } from "../../api/service/service.api";

export const fetchServices = createFetchThunk({
  typePrefix: "services/fetch",
  apiFn: getServiceApi,
  errorMessage: "Failed to fetch Services",
});
